import { Component, EventEmitter, Input, Output } from '@angular/core'
import { CommonModule } from '@angular/common'

import { QuestionnaireSection, Submission } from '../../models/questionnaire.model'
import { QuestionnaireReviewComponent } from '../questionnaire-review/questionnaire-review.component'

@Component({
  selector: 'app-carry-forward-preview',
  templateUrl: './carry-forward-preview.component.html',
  styleUrls: ['./carry-forward-preview.component.scss'],
  standalone: true,
  imports: [CommonModule, QuestionnaireReviewComponent]
})
export class CarryForwardPreviewComponent {
  @Input() questionnaire: QuestionnaireSection[] = []
  @Input() previousSubmission: Submission | null = null
  @Input() loading: boolean = false
  @Output() confirm = new EventEmitter<void>()
  @Output() edit = new EventEmitter<void>()
  @Output() startFresh = new EventEmitter<void>()

  onConfirm(): void {
    this.confirm.emit()
  }

  onEdit(): void {
    this.edit.emit()
  }

  onStartFresh(): void {
    this.startFresh.emit()
  }
}
